import { Navigate } from 'react-router-dom';
import routes from '@/app/routes';
import ErrorPage from '@/pages/error';

const AuthRoute = ({ isAuthenticated, children }: any) => {
  if (!children) {
    return <ErrorPage errorStatusCode={404} />;
  }

  return isAuthenticated ? (
    children
  ) : (
    <Navigate to={routes.LOGIN} replace state={{ from: window.location.pathname }} />
  );
};

export default AuthRoute;
